import template from './secureFileUploaderValidateError.html';
import controller from './secureFileUploaderValidateError.controller';

let secureFileUploaderValidateErrorComponent = {
  restrict: 'E',
  bindings: {
    uploadState: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default secureFileUploaderValidateErrorComponent;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderValidateError/secureFileUploaderValidateError.component.js